import { Stack } from '@mui/material';
import { clamp } from 'lodash';
import { FC, useCallback } from 'react';
import { NumberInput, required } from 'react-admin';

interface Props {
  columnIdx: number;
  rowIdx: number;
  testId: string;
}

export const B2bInvestorProfileGridColumnTextInput: FC<Props> = (props) => {
  const { columnIdx, rowIdx, testId } = props;

  const parseValue = useCallback((value: number) => clamp(value, 0, 100), []);

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <NumberInput
        source={`grid.${columnIdx}.allocation.${rowIdx}`}
        shouldUnregister
        label={false}
        sx={{ maxWidth: 66, height: 58 }}
        max={100}
        min={0}
        validate={[required()]}
        parse={parseValue}
        data-testid={testId}
      />
      <span>%</span>
    </Stack>
  );
};
